import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TripBookingDispatchPlaceFilter,
  TripBookingDispatchPlaceMappingType
} from '../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AffectedStaffSalary = {
  basePrice: number
  bonusPrice: number
}

export function getTripBookingDispatchPlaces<T extends keyof TripBookingDispatchPlaceMappingType>(
  input: PaginationRequest<TripBookingDispatchPlaceFilter>
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.tripBookingDispatchPlaces.getAll.url, null), input)
    )
    .get<PaginationResponse<TripBookingDispatchPlaceMappingType[T]>>()
}
